(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6868,995],{

/***/ 24697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-career-report-2022",
      function () {
        return __webpack_require__(36013);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ FOOTER_NAV_SOCIAL; },
/* harmony export */   "h2": function() { return /* binding */ FOOTER_NAV_GROUPS; },
/* harmony export */   "vN": function() { return /* binding */ FOOTER_NAV_SECONDARY; }
/* harmony export */ });
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97143);
/* harmony import */ var features_job_offers_list_components_JobOffersListComponent_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82324);
/* harmony import */ var components_shared_XTwitterIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66334);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62177);
/* harmony import */ var utils_job_offers_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55920);
/* harmony import */ var utils_localize_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38062);






var FOOTER_NAV_GROUPS = function(t, locale) {
    return [
        {
            title: t("nav.talentTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.talent */ .uu.talent, locale)),
                    title: t("nav.product")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.manfredDaily */ .uu.manfredDaily, locale)),
                    title: t("nav.telegramOffers")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.jobOffers */ .uu.jobOffers, locale), "?").concat((0,utils_job_offers_filter__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParamsFromJobOffersFilter */ .Ci)(features_job_offers_list_components_JobOffersListComponent_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_FILTER */ .XW, (0,utils_localize_utils__WEBPACK_IMPORTED_MODULE_4__/* .getLocale */ .K)(locale))),
                    title: t("nav.offers")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.salaryCompass */ .uu.salaryCompass, locale)),
                    title: t("nav.salaryCompass")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.roles */ .uu.roles, locale)),
                    title: t("nav.roles")
                }
            ]
        },
        {
            title: t("nav.companiesTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.companies */ .uu.companies, locale)),
                    title: t("nav.services")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.yourOfferSalary */ .uu.yourOfferSalary, locale)),
                    title: t("nav.yourOfferSalary")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.hrAsAService */ .uu.hrAsAService, locale)),
                    title: t("nav.hr-as-a-service")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.manfredDailyCompanies */ .uu.manfredDailyCompanies, locale)),
                    title: t("nav.daily")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.outOfOffice */ .uu.outOfOffice, locale)),
                    title: t("nav.outOfOffice")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.helpingCompanies */ .uu.helpingCompanies, locale)),
                    title: t("nav.helpingCompanies")
                }
            ]
        },
        {
            title: t("nav.knowledgeTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.blog */ .uu.blog, locale)),
                    title: t("nav.blog")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.mantechcar25 */ .uu.mantechcar25, locale)),
                    title: t("nav.stateOfTheSector")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.hiringProcessComparison */ .uu.hiringProcessComparison, locale)),
                    title: t("nav.hiringProcessComparison")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.helpingJuniors */ .uu.helpingJuniors, locale)),
                    title: t("nav.helpingJuniors")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.stateOfHiring */ .uu.stateOfHiring, locale)),
                    title: t("nav.hiringReport")
                }
            ]
        },
        {
            title: t("nav.manfredTitle"),
            navItems: [
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.team */ .uu.team, locale)),
                    title: t("nav.us")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.blog */ .uu.blog, locale), "/compromiso-etico-manfred"),
                    title: t("nav.ethicalCommitment")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.battleReport */ .uu.battleReport, locale)),
                    title: t("nav.battleReport")
                },
                {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.joinUs */ .uu.joinUs, locale)),
                    title: t("nav.joinUs")
                }
            ]
        }
    ];
};
var FOOTER_NAV_SECONDARY = function(t, locale) {
    return [
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.termsOfUse */ .uu.termsOfUse, locale)),
            title: t("nav.terms")
        },
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.privacyPolicy */ .uu.privacyPolicy, locale)),
            title: t("nav.privacy")
        },
        {
            href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_2__/* .APP_URLS.cookies */ .uu.cookies, locale)),
            title: t("nav.cookies")
        }
    ];
};
var FOOTER_NAV_SOCIAL = function() {
    return [
        {
            title: "X",
            href: "https://x.com/getmanfred",
            icon: components_shared_XTwitterIcon__WEBPACK_IMPORTED_MODULE_1__/* .faXTwitter */ .N
        },
        {
            title: "Twitch",
            href: "https://www.twitch.tv/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTwitch */ .z0T
        },
        {
            title: "LinkedIn",
            href: "https://es.linkedin.com/company/manfred/",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faLinkedin */ .D9H
        },
        {
            title: "GitHub",
            href: "https://github.com/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faGithub */ .zhw
        },
        {
            title: "Telegram",
            href: "https://t.me/getmanfred",
            icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTelegramPlane */ .IKq
        }
    ];
};


/***/ }),

/***/ 59072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ StyledNavGroup; },
/* harmony export */   "Dr": function() { return /* binding */ StyledFooterMain; },
/* harmony export */   "GS": function() { return /* binding */ StyledFooterLogoLang; },
/* harmony export */   "Gr": function() { return /* binding */ StyledFooterContainer; },
/* harmony export */   "LX": function() { return /* binding */ StyledFooterSecondary; },
/* harmony export */   "Oo": function() { return /* binding */ StyledFooterCopyright; },
/* harmony export */   "Re": function() { return /* binding */ StyledFooterNavItem; },
/* harmony export */   "Tu": function() { return /* binding */ StyledNavGroupTitle; },
/* harmony export */   "jO": function() { return /* binding */ StyledFooterNavCopy; },
/* harmony export */   "tc": function() { return /* binding */ StyledFooter; },
/* harmony export */   "xp": function() { return /* binding */ StyledFooterNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Dropdown_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23211);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);
/* harmony import */ var _topbar_TopbarLanguage_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21058);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  color: ",
        ";\n\n  &.not-scrollTop {\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  img {\n    display: block;\n    width: auto;\n    height: ",
        ";\n  }\n\n  ",
        " button {\n    margin: 0;\n    padding: 0;\n    color: ",
        ";\n    min-height: auto;\n\n    &:hover {\n      color: inherit;\n      background-color: transparent;\n    }\n\n    &::after {\n      background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730957H7.46171C7.94067 0.730957 8.18015 1.30948 7.84111 1.64852L4.38075 5.11158C4.17087 5.32146 3.82913 5.32146 3.61925 5.11158L0.158886 1.64852C-0.180154 1.30948 0.0593268 0.730957 0.538289 0.730957Z' fill='%23DEDCE4'/%3E%3C/svg%3E%0A\");\n    }\n  }\n\n  ",
        " {\n    left: 0;\n    right: unset;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  @media (min-width: ",
        ") {\n    justify-content: flex-end;\n    margin-left: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    max-width: 11rem;\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active,\n  &.active {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  ul {\n    display: flex;\n    gap: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:active,\n    &.active {\n      color: ",
        ";\n    }\n\n    svg {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var StyledFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].footer.withConfig */ .ZP.footer.withConfig({
    componentId: "sc-a503a5bd-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_900"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default_inverse"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl3"));
var StyledFooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("xlMax"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFooterMain = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("lg"));
var StyledFooterLogoLang = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), _topbar_TopbarLanguage_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledLanguage */ .j, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default_inverse"), components_shared_Dropdown_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledDropdown */ .EI, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_default"));
var StyledFooterCopyright = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].small.withConfig */ .ZP.small.withConfig({
    componentId: "sc-a503a5bd-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle_inverse"));
var StyledFooterNav = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].nav.withConfig */ .ZP.nav.withConfig({
    componentId: "sc-a503a5bd-5"
})(_templateObject5(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("lg"));
var StyledNavGroup = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-6"
})(_templateObject6(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("sm"));
var StyledNavGroupTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-7"
})(_templateObject7(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"));
var StyledFooterNavItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-a503a5bd-8"
})(_templateObject8(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_hover"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_active"));
var StyledFooterNavCopy = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-9"
})(_templateObject9(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl2"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_800"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledFooterSecondary = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a503a5bd-10"
})(_templateObject10(), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), StyledFooterNavItem, (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_white"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_hover"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("link_inverse_active"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("mdlg"), (0,theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("mdlg"));


/***/ }),

/***/ 70995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _asgard_ui_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78197);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49929);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39105);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66582);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40286);
/* harmony import */ var utils_logos__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4335);
/* harmony import */ var utils_paths__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64516);
/* harmony import */ var _topbar_TopbarLanguage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74971);
/* harmony import */ var _Footer_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90182);
/* harmony import */ var _Footer_styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59072);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  body {\n    padding-bottom: ",
        ";\n  }\n\n  @media (max-height: ",
        ") {\n    body {\n      padding-bottom: 0 !important;\n    }\n    .main-footer {\n      position: static !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .createGlobalStyle */ .vJ)(_templateObject(), function(props) {
    return props.footerHeight ? props.footerHeight + "px !important" : "";
}, function(props) {
    return props.footerHeight + "px";
});
var Footer = function(param) {
    var offerFooter = param.offerFooter, hasScrollTop = param.hasScrollTop, isInCustomFooter = param.isInCustomFooter;
    var footerHeight = function footerHeight() {
        if (footerRef === null || footerRef === void 0 ? void 0 : footerRef.current) {
            setHeight(footerRef.current.clientHeight);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(0), height = ref[0], setHeight = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), year = ref1[0], setYear = ref1[1];
    var footerRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_4__/* .useI18n */ .Q)("footer").t;
    var locale = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        footerHeight();
        var triggerEvent = react_device_detect__WEBPACK_IMPORTED_MODULE_8__/* .isMobile */ .tq ? "orientationchange" : "resize";
        window.addEventListener(triggerEvent, footerHeight);
        return function() {
            window.removeEventListener(triggerEvent, footerHeight);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        setYear(new Date().getFullYear());
    }, []);
    var footerNav = (0,_Footer_constants__WEBPACK_IMPORTED_MODULE_10__/* .FOOTER_NAV_GROUPS */ .h2)(t, locale);
    var footerNavSecondary = (0,_Footer_constants__WEBPACK_IMPORTED_MODULE_10__/* .FOOTER_NAV_SECONDARY */ .vN)(t, locale);
    var footerNavSocial = (0,_Footer_constants__WEBPACK_IMPORTED_MODULE_10__/* .FOOTER_NAV_SOCIAL */ .Rw)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GlobalStyle, {
                footerHeight: height
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooter */ .tc, {
                ref: isInCustomFooter ? undefined : footerRef,
                className: "".concat(isInCustomFooter ? "" : "main-footer", " ").concat(offerFooter && !hasScrollTop ? "not-scrollTop" : ""),
                children: [
                    offerFooter,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterContainer */ .Gr, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterMain */ .Dr, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterLogoLang */ .GS, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                loading: "lazy",
                                                src: utils_logos__WEBPACK_IMPORTED_MODULE_13__/* .LOGO_MANFRED_WHITE */ .YM,
                                                alt: "Manfred logo",
                                                width: "132",
                                                height: "24"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_topbar_TopbarLanguage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNav */ .xp, {
                                        "aria-label": t("nav.label"),
                                        children: footerNav.map(function(group, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledNavGroup */ .$H, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledNavGroupTitle */ .Tu, {
                                                        children: group.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                                        children: group.navItems.map(function(navItem, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                                        href: navItem.href,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNavItem */ .Re, {
                                                                            children: navItem.title
                                                                        })
                                                                    })
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    group.action && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: group.action
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNavCopy */ .jO, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterCopyright */ .Oo, {
                                        children: [
                                            "\xa9 ",
                                            year,
                                            " ",
                                            t("nav.manfredTech")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterSecondary */ .LX, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                                children: footerNavSecondary.map(function(navItem, index) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                            href: navItem.href,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer_styled__WEBPACK_IMPORTED_MODULE_11__/* .StyledFooterNavItem */ .Re, {
                                                                children: navItem.title
                                                            })
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_asgard_ui_library__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
                                                alignment: "center",
                                                style: {
                                                    flexDirection: "row"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        href: "/humans.txt",
                                                        target: "_blank",
                                                        rel: "noreferrer noopener",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                            loading: "lazy",
                                                            src: (0,utils_paths__WEBPACK_IMPORTED_MODULE_14__/* .getPublicPath */ .A)("/images/humanstxt.png"),
                                                            alt: "Humans.txt logo"
                                                        })
                                                    }),
                                                    footerNavSocial.map(function(navItem, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            title: navItem.title,
                                                            href: navItem.href,
                                                            target: "_blank",
                                                            rel: "noreferrer noopener",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                                icon: navItem.icon
                                                            })
                                                        }, index);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 55952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* reexport safe */ _Badge_styled__WEBPACK_IMPORTED_MODULE_0__.C; }
/* harmony export */ });
/* harmony import */ var _Badge_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71487);



/***/ }),

/***/ 36013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ developer_career_report_2022; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Badge.js
var Badge = __webpack_require__(55952);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(28870);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/Benchmark.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  background-image: linear-gradient(\n      ",
        ",\n      ",
        "\n    ),\n    url('",
        "');\n  background-size: cover;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  p {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 18rem;\n  flex-shrink: 0;\n\n  img {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e95bda70-0"
})(_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,polished_esm/* rgba */.m4)("#1f1d26", 0.75), (0,polished_esm/* rgba */.m4)("#1f1d26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/hero-bg.gif"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e95bda70-1"
})(_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* screen */.sp)("md"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e95bda70-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e95bda70-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/Benchmark.tsx













var Benchmark = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            variant: "secondaryInverse",
                            children: t("benchmark.soon")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                            as: "h4",
                            children: t("benchmark.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("benchmark.desc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=banner-career-report"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                variant: "brandTalent",
                                onClick: function(e) {
                                    return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=banner-career-report"), "banner-career-report");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("benchmark.cta")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/stateSector/benchmark.svg"),
                        alt: ""
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Benchmark = (Benchmark);

// EXTERNAL MODULE: ./components/shared/RadioButton.tsx
var RadioButton = __webpack_require__(73273);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(61660);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(80739);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(25556);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(3131);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(47857);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(24908);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/MethodologyAnchor.styled.tsx

function MethodologyAnchor_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  gap: ",
        ";\n  margin-left: 105px;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    MethodologyAnchor_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ea70cc11-0"
})(MethodologyAnchor_styled_templateObject(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs2"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/MethodologyAnchor.tsx





var MethodologyAnchor = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAnchor, {
        href: "#methodology",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faInfoCircle */.sqG
            }),
            t("methodology-anchor")
        ]
    });
};
/* harmony default export */ var components_MethodologyAnchor = (MethodologyAnchor);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/Recharts.styled.tsx

function Recharts_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    overflow-x: auto;\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    border-radius: ",
        " !important;\n    flex: 0 0 auto;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n  &.dark {\n    .recharts-text {\n      fill: ",
        ";\n    }\n  }\n  &.methodology {\n    .recharts-text {\n      font-size: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.gender-by-role {\n    .recharts-text {\n      font-size: ",
        ";\n    }\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    display: flex !important;\n    align-items: center;\n  }\n\n  &.gender .recharts-legend-item {\n    display: inline-flex !important;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n\n  &.radial .recharts-default-legend {\n    display: flex;\n    flex-wrap: wrap;\n  }\n"
    ]);
    Recharts_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledRecharts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c07f849-0"
})(Recharts_styled_templateObject(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MostWantedLanguages.tsx




var MostWantedLanguages = function() {
    var data = [
        {
            language: "JavaScript",
            value: 22.319474835886215,
            fill: "#08306B"
        },
        {
            language: "Python",
            value: 17.067833698030636,
            fill: "#08306B"
        },
        {
            language: "JAVA",
            value: 15.75492341356674,
            fill: "#08519C"
        },
        {
            language: "PHP",
            value: 10.50328227571116,
            fill: "#08519C"
        },
        {
            language: "TypeScript",
            value: 7.439824945295405,
            fill: "#2171B5"
        },
        {
            language: "Kotlin",
            value: 4.595185995623632,
            fill: "#2171B5"
        },
        {
            language: "C#",
            value: 3.7199124726477026,
            fill: "#4292C6"
        },
        {
            language: "C++",
            value: 2.62582056892779,
            fill: "#4292C6"
        },
        {
            language: "Go",
            value: 2.62582056892779,
            fill: "#6BAED6"
        },
        {
            language: "Ruby",
            value: 2.1881838074398248,
            fill: "#6BAED6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    40
                                ],
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostWantedLanguages = (MostWantedLanguages);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MostWantedTechnologies.tsx




var MostWantedTechnologies = function() {
    var data = [
        {
            language: "AWS",
            value: 28.00875273522976,
            fill: "#08306B"
        },
        {
            language: "React",
            value: 18.38074398249453,
            fill: "#08306B"
        },
        {
            language: "CSS",
            value: 15.098468271334792,
            fill: "#08519C"
        },
        {
            language: "NodeJS",
            value: 15.098468271334792,
            fill: "#08519C"
        },
        {
            language: "HTML",
            value: 14.00437636761488,
            fill: "#2171B5"
        },
        {
            language: "Docker",
            value: 13.566739606126916,
            fill: "#2171B5"
        },
        {
            language: "MySQL",
            value: 9.409190371991247,
            fill: "#4292C6"
        },
        {
            language: "MongoDB",
            value: 8.752735229759299,
            fill: "#4292C6"
        },
        {
            language: "PostgreSQL",
            value: 8.533916849015318,
            fill: "#6BAED6"
        },
        {
            language: "Kubernetes",
            value: 8.533916849015318,
            fill: "#6BAED6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    40
                                ],
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostWantedTechnologies = (MostWantedTechnologies);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/CompaniesSection.styled.tsx

function CompaniesSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    CompaniesSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompaniesSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    CompaniesSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompaniesSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    CompaniesSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompaniesSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    CompaniesSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: center;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-align: center;\n  margin: ",
        " auto;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var CompaniesSection_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-0"
})(CompaniesSection_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"));
var CompaniesSection_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-1"
})(CompaniesSection_styled_templateObject1(), (0,theme/* container */.nC)("md"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-2"
})(CompaniesSection_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"));
var StyledSubsection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-3"
})(CompaniesSection_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var StyledSubsectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("text_subtle_inverse"));
var StyledSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"));
var StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ecdb67d4-6"
})(_templateObject6(), (0,theme/* container */.nC)("lg"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/LocationPreference.styled.tsx

function LocationPreference_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    LocationPreference_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  gap: ",
        ";\n  text-align: center;\n  margin: 0;\n  transition: 0.3s;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  &:hover ",
        " {\n    opacity: 0.5;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n    align-items: flex-end;\n  }\n"
    ]);
    LocationPreference_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.25;\n  white-space: nowrap;\n"
    ]);
    LocationPreference_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  &.big {\n    width: 13.75rem;\n    height: 13.75rem;\n    background-color: ",
        ";\n  }\n\n  &.medium {\n    width: 9.125rem;\n    height: 9.125rem;\n    background-color: ",
        ";\n  }\n\n  &.small {\n    width: 6.875rem;\n    height: 6.875rem;\n    background-color: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var LocationPreference_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-986ae2c9-0"
})(LocationPreference_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl3"));
var StyledItem = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-986ae2c9-1"
})(LocationPreference_styled_templateObject1(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-986ae2c9-2"
})(LocationPreference_styled_templateObject2(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), StyledItem, (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-986ae2c9-3"
})(LocationPreference_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("medium"));
var StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-986ae2c9-4"
})(LocationPreference_styled_templateObject4(), (0,theme/* radius */.q0)("full"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_white"), (0,theme/* color */.$_)("ylgnbu_08"), (0,theme/* color */.$_)("ylgnbu_06"), (0,theme/* color */.$_)("ylgnbu_04"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/LocationsOffered.tsx





var LocationsOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var items = [
        {
            type: "big",
            value: 87.74617067833698,
            label: t("developers.location.remote")
        },
        {
            type: "medium",
            value: 35.44857768052516,
            label: t("developers.location.onsite")
        },
        {
            type: "small",
            value: 10.50328227571116,
            label: t("developers.location.hybrid")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationPreference_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                children: t("companies.locations.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: t("companies.locations.desc")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                className: item.type,
                                children: [
                                    item.value.toFixed(1),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                                children: item.label
                            })
                        ]
                    }, item.type);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var components_LocationsOffered = (LocationsOffered);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/CompaniesSection.tsx









var CompaniesSection = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var ref = (0,react.useState)(true), mostWantedLangs = ref[0], setMostWantedLangs = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompaniesSection_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompaniesSection_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                as: "h2",
                                editorial: true,
                                children: t("companies.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("companies.desc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubsection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubsectionHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        children: t("companies.most-wanted.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("companies.most-wanted.desc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitcher, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                        name: "mostWantedTechs",
                                        id: "mostWantedLangs",
                                        label: t("companies.most-wanted.switcher.languages"),
                                        onChange: function() {
                                            return setMostWantedLangs(true);
                                        },
                                        checked: mostWantedLangs
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                        name: "mostWantedTechs",
                                        id: "mostWantedTechs",
                                        label: t("companies.most-wanted.switcher.technologies"),
                                        onChange: function() {
                                            return setMostWantedLangs(false);
                                        },
                                        checked: !mostWantedLangs
                                    })
                                ]
                            }),
                            mostWantedLangs && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostWantedLanguages, {}),
                            !mostWantedLangs && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostWantedTechnologies, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LocationsOffered, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlight, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("companies.highlight")
                })
            })
        ]
    });
};
/* harmony default export */ var components_CompaniesSection = (CompaniesSection);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/LeastWantedLanguages.tsx




var LeastWantedLanguages = function() {
    var data = [
        {
            language: "JAVA",
            value: 34.25925925925926,
            fill: "#08306B"
        },
        {
            language: "PHP",
            value: 26.851851851851855,
            fill: "#08306B"
        },
        {
            language: "Python",
            value: 7.828282828282829,
            fill: "#08519C"
        },
        {
            language: "JavaScript",
            value: 6.481481481481481,
            fill: "#08519C"
        },
        {
            language: "C++",
            value: 6.313131313131313,
            fill: "#2171B5"
        },
        {
            language: "Cobol",
            value: 5.892255892255893,
            fill: "#2171B5"
        },
        {
            language: "C#",
            value: 5.723905723905724,
            fill: "#4292C6"
        },
        {
            language: "C",
            value: 2.6094276094276094,
            fill: "#4292C6"
        },
        {
            language: "Visual Basic",
            value: 2.525252525252525,
            fill: "#6BAED6"
        },
        {
            language: "Ruby",
            value: 1.5151515151515151,
            fill: "#6BAED6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    40
                                ],
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_LeastWantedLanguages = (LeastWantedLanguages);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/LeastWantedTechnologies.tsx




var LeastWantedTechnologies = function() {
    var data = [
        {
            language: "AngularJS",
            value: 20.098039215686274,
            fill: "#08306B"
        },
        {
            language: ".NET",
            value: 15.849673202614378,
            fill: "#08306B"
        },
        {
            language: "Angular2+",
            value: 13.725490196078432,
            fill: "#08519C"
        },
        {
            language: "React",
            value: 10.620915032679738,
            fill: "#08519C"
        },
        {
            language: "Windows",
            value: 8.49673202614379,
            fill: "#2171B5"
        },
        {
            language: "WordPress",
            value: 8.333333333333332,
            fill: "#2171B5"
        },
        {
            language: "jQuery",
            value: 7.026143790849673,
            fill: "#4292C6"
        },
        {
            language: "CSS",
            value: 6.862745098039216,
            fill: "#4292C6"
        },
        {
            language: "HTML",
            value: 5.065359477124183,
            fill: "#6BAED6"
        },
        {
            language: "Vue",
            value: 3.9215686274509802,
            fill: "#6BAED6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    40
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_LeastWantedTechnologies = (LeastWantedTechnologies);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MostUsedLanguages.tsx




var MostUsedLanguages = function() {
    var data = [
        {
            language: "JavaScript",
            value: 27.484859280370504,
            fill: "#08306B"
        },
        {
            language: "JAVA",
            value: 18.444959030993942,
            fill: "#08306B"
        },
        {
            language: "Python",
            value: 16.467759173494834,
            fill: "#08519C"
        },
        {
            language: "PHP",
            value: 11.400071250445315,
            fill: "#08519C"
        },
        {
            language: "TypeScript",
            value: 9.05771286070538,
            fill: "#2171B5"
        },
        {
            language: "C#",
            value: 5.7801923762023515,
            fill: "#2171B5"
        },
        {
            language: "C++",
            value: 3.509084431777699,
            fill: "#4292C6"
        },
        {
            language: "Bash",
            value: 2.8232988956180973,
            fill: "#4292C6"
        },
        {
            language: "Kotlin",
            value: 2.6540790879942997,
            fill: "#6BAED6"
        },
        {
            language: "C",
            value: 2.3779836123975775,
            fill: "#6BAED6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    40
                                ],
                                tickFormatter: function(tick) {
                                    return "".concat(tick, "%");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostUsedLanguages = (MostUsedLanguages);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MostUsedTechnologies.tsx




var MostUsedTechnologies = function() {
    var data = [
        {
            language: "CSS",
            value: 13.751430205949658,
            fill: "#08306B"
        },
        {
            language: "React",
            value: 11.806350114416476,
            fill: "#08306B"
        },
        {
            language: "MySQL",
            value: 11.799199084668192,
            fill: "#08519C"
        },
        {
            language: "HTML",
            value: 11.613272311212814,
            fill: "#08519C"
        },
        {
            language: "Git",
            value: 10.948226544622425,
            fill: "#2171B5"
        },
        {
            language: "Docker",
            value: 8.724256292906178,
            fill: "#2171B5"
        },
        {
            language: "SQL",
            value: 8.531178489702517,
            fill: "#4292C6"
        },
        {
            language: "NodeJS",
            value: 8.445366132723112,
            fill: "#4292C6"
        },
        {
            language: "MongoDB",
            value: 7.73741418764302,
            fill: "#6BAED6"
        },
        {
            language: "AWS",
            value: 6.643306636155606,
            fill: "#6BAED6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "dark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                allowDecimals: false,
                                tickLine: false,
                                padding: {
                                    left: 20
                                },
                                domain: [
                                    0,
                                    40
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "language",
                                tickLine: false,
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: "",
                                formatter: function(value) {
                                    return [
                                        value.toFixed(1) + "%",
                                        ""
                                    ];
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "value",
                                fill: "fill",
                                barSize: 12,
                                radius: 5
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_MostUsedTechnologies = (MostUsedTechnologies);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/DevelopersSection.styled.tsx

function DevelopersSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    DevelopersSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DevelopersSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  color: ",
        ";\n"
    ]);
    DevelopersSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DevelopersSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    DevelopersSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DevelopersSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    DevelopersSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DevelopersSection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    DevelopersSection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DevelopersSection_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: center;\n    gap: ",
        ";\n  }\n"
    ]);
    DevelopersSection_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DevelopersSection_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    DevelopersSection_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var DevelopersSection_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-0"
})(DevelopersSection_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"));
var DevelopersSection_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-1"
})(DevelopersSection_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("text_default_inverse"));
var DevelopersSection_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-2"
})(DevelopersSection_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"));
var DevelopersSection_styled_StyledSubsection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-3"
})(DevelopersSection_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var DevelopersSection_styled_StyledSubsectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-4"
})(DevelopersSection_styled_templateObject4(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("text_subtle_inverse"));
var DevelopersSection_styled_StyledSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-5"
})(DevelopersSection_styled_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"));
var DevelopersSection_styled_StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29903001-6"
})(DevelopersSection_styled_templateObject6(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* color */.$_)("navy_300"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/LocationPreference.tsx





var LocationPreference = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var items = [
        {
            type: "big",
            value: 61.41035401598782,
            label: t("developers.location.remote")
        },
        {
            type: "medium",
            value: 31.747240197944425,
            label: t("developers.location.hybrid")
        },
        {
            type: "small",
            value: 11.36277122192615,
            label: t("developers.location.onsite")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationPreference_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                children: t("developers.location.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: t("developers.location.desc")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                className: item.type,
                                children: [
                                    item.value.toFixed(1),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                                children: item.label
                            })
                        ]
                    }, item.type);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var components_LocationPreference = (LocationPreference);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/DevelopersSection.tsx











var DevelopersSection = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var ref = (0,react.useState)(true), mostUsedLangs = ref[0], setMostUsedLangs = ref[1];
    var ref1 = (0,react.useState)(true), leastWantedLangs = ref1[0], setLeastWantedLangs = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DevelopersSection_styled_StyledSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                            as: "h2",
                            editorial: true,
                            children: t("developers.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("developers.desc")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                    children: t("developers.most-used.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("developers.most-used.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledSwitcher, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                    name: "mostUsedTechs",
                                    id: "mostUsedLangs",
                                    label: t("developers.most-used.switcher.languages"),
                                    onChange: function() {
                                        return setMostUsedLangs(true);
                                    },
                                    checked: mostUsedLangs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                    name: "mostUsedTechs",
                                    id: "mostUsedTechs",
                                    label: t("developers.most-used.switcher.technologies"),
                                    onChange: function() {
                                        return setMostUsedLangs(false);
                                    },
                                    checked: !mostUsedLangs
                                })
                            ]
                        }),
                        mostUsedLangs && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedLanguages, {}),
                        !mostUsedLangs && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechnologies, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                    children: t("developers.least-wanted.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("developers.least-wanted.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DevelopersSection_styled_StyledSwitcher, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                    name: "leastWantedTechs",
                                    id: "leastWantedLangs",
                                    label: t("developers.least-wanted.switcher.languages"),
                                    onChange: function() {
                                        return setLeastWantedLangs(true);
                                    },
                                    checked: leastWantedLangs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                    name: "leastWantedTechs",
                                    id: "leastWantedTechs",
                                    label: t("developers.least-wanted.switcher.technologies"),
                                    onChange: function() {
                                        return setLeastWantedLangs(false);
                                    },
                                    checked: !leastWantedLangs
                                })
                            ]
                        }),
                        leastWantedLangs && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedLanguages, {}),
                        !leastWantedLangs && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechnologies, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevelopersSection_styled_StyledHighlight, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("developers.highlight")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LocationPreference, {})
            ]
        })
    });
};
/* harmony default export */ var components_DevelopersSection = (DevelopersSection);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Legend.js + 1 modules
var Legend = __webpack_require__(55734);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/GenderByRole.tsx





var GenderByRole = function() {
    var locale = (0,router.useRouter)().locale;
    var dataEN = [
        {
            role: "Backend Developer",
            Women: 7.7304964539007095,
            Men: 92.05673758865248
        },
        {
            role: "Full-stack Developer",
            Women: 9.695901278096079,
            Men: 89.95152049360952
        },
        {
            role: "Frontend Developer",
            Women: 15.035460992907801,
            Men: 84.53900709219859
        },
        {
            role: "Mobile Developer",
            Women: 8.899297423887589,
            Men: 90.39812646370024
        },
        {
            role: "Software Architect",
            Women: 5.150976909413854,
            Men: 94.31616341030195
        },
        {
            role: "DevOps, Infrastructure & SRE",
            Women: 4.651162790697675,
            Men: 95.01661129568106
        },
        {
            role: "SysAdmin",
            Women: 6.666666666666667,
            Men: 93.33333333333333
        },
        {
            role: "Design",
            Women: 48.19277108433735,
            Men: 51.80722891566265
        },
        {
            role: "Product Manager",
            Women: 23.157894736842106,
            Men: 76.57894736842105
        },
        {
            role: "Data Analysis & BI",
            Women: 15.112540192926044,
            Men: 84.56591639871382
        },
        {
            role: "QA & Testing Engineer",
            Women: 19.45945945945946,
            Men: 80
        },
        {
            role: "Project & Delivery Manager",
            Women: 19.507575757575758,
            Men: 80.49242424242425
        },
        {
            role: "Data Scientist",
            Women: 13.432835820895523,
            Men: 86.56716417910447
        },
        {
            role: "Data Engineer",
            Women: 6.870229007633588,
            Men: 92.87531806615776
        },
        {
            role: "Engineering Manager",
            Women: 8.390022675736962,
            Men: 90.9297052154195
        },
        {
            role: "Tech Lead",
            Women: 4.545454545454546,
            Men: 95.05347593582889
        }
    ].sort(function(a, b) {
        return a.Women > b.Women ? -1 : 1;
    });
    var dataES = [
        {
            role: "Backend Developer",
            Mujeres: 7.7304964539007095,
            Hombres: 92.05673758865248
        },
        {
            role: "Full-stack Developer",
            Mujeres: 9.695901278096079,
            Hombres: 89.95152049360952
        },
        {
            role: "Frontend Developer",
            Mujeres: 15.035460992907801,
            Hombres: 84.53900709219859
        },
        {
            role: "Mobile Developer",
            Mujeres: 8.899297423887589,
            Hombres: 90.39812646370024
        },
        {
            role: "Software Architect",
            Mujeres: 5.150976909413854,
            Hombres: 94.31616341030195
        },
        {
            role: "DevOps, Infrastructure & SRE",
            Mujeres: 4.651162790697675,
            Hombres: 95.01661129568106
        },
        {
            role: "SysAdmin",
            Mujeres: 6.666666666666667,
            Hombres: 93.33333333333333
        },
        {
            role: "Design",
            Mujeres: 48.19277108433735,
            Hombres: 51.80722891566265
        },
        {
            role: "Product Manager",
            Mujeres: 23.157894736842106,
            Hombres: 76.57894736842105
        },
        {
            role: "Data Analysis & BI",
            Mujeres: 15.112540192926044,
            Hombres: 84.56591639871382
        },
        {
            role: "QA & Testing Engineer",
            Mujeres: 19.45945945945946,
            Hombres: 80
        },
        {
            role: "Project & Delivery Manager",
            Mujeres: 19.507575757575758,
            Hombres: 80.49242424242425
        },
        {
            role: "Data Scientist",
            Mujeres: 13.432835820895523,
            Hombres: 86.56716417910447
        },
        {
            role: "Data Engineer",
            Mujeres: 6.870229007633588,
            Hombres: 92.87531806615776
        },
        {
            role: "Engineering Manager",
            Mujeres: 8.390022675736962,
            Hombres: 90.9297052154195
        },
        {
            role: "Tech Lead",
            Mujeres: 4.545454545454546,
            Hombres: 95.05347593582889
        }
    ].sort(function(a, b) {
        return a.Mujeres > b.Mujeres ? -1 : 1;
    });
    var data = locale === "es" ? dataES : dataEN;
    var womenKey = locale === "es" ? "Mujeres" : "Women";
    var menKey = locale === "es" ? "Hombres" : "Men";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "gender gender-by-role",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 550,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        layout: "vertical",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "number",
                                hide: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                type: "category",
                                dataKey: "role",
                                tickLine: false,
                                width: 210,
                                axisLine: false,
                                tickMargin: 10
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return value.toFixed(1) + "%";
                                },
                                wrapperClassName: "tooltip-y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: -5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: womenKey,
                                stackId: "a",
                                barSize: 12,
                                radius: [
                                    5,
                                    0,
                                    0,
                                    5
                                ],
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: menKey,
                                stackId: "a",
                                barSize: 12,
                                radius: [
                                    0,
                                    5,
                                    5,
                                    0
                                ],
                                fill: "#1B9D76"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_GenderByRole = (GenderByRole);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/GenderSalaryByExperience.tsx





var GenderSalaryByExperience = function() {
    var locale = (0,router.useRouter)().locale;
    var dataEN = [
        {
            exp: "<2y",
            Men: 24.254045307443363,
            Women: 25.346863468634684
        },
        {
            exp: "2-5y",
            Men: 37.86383442265795,
            Women: 33.21071428571428
        },
        {
            exp: "5-10y",
            Men: 47.737415477084895,
            Women: 41.12234042553192
        },
        {
            exp: ">10y",
            Men: 53.20698510529019,
            Women: 48.737430167597765
        },
        {
            exp: "Not specified",
            Men: 23.15841584158416,
            Women: 24.48770491803279
        }
    ];
    var dataES = [
        {
            exp: "<2y",
            Hombres: 24.254045307443363,
            Mujeres: 25.346863468634684
        },
        {
            exp: "2-5y",
            Hombres: 37.86383442265795,
            Mujeres: 33.21071428571428
        },
        {
            exp: "5-10y",
            Hombres: 47.737415477084895,
            Mujeres: 41.12234042553192
        },
        {
            exp: ">10y",
            Hombres: 53.20698510529019,
            Mujeres: 48.737430167597765
        },
        {
            exp: "No especificado",
            Hombres: 23.15841584158416,
            Mujeres: 24.48770491803279
        }
    ];
    var data = locale === "es" ? dataES : dataEN;
    var womenKey = locale === "es" ? "Mujeres" : "Women";
    var menKey = locale === "es" ? "Hombres" : "Men";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "gender",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 450,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "category",
                                dataKey: "exp",
                                tickLine: false,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                width: 60,
                                axisLine: false,
                                tickMargin: 5,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                padding: {
                                    bottom: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€".concat(value.toFixed(1), "K");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: -5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: womenKey,
                                barSize: 12,
                                radius: 5,
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: menKey,
                                barSize: 12,
                                radius: 5,
                                fill: "#1B9D76"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_GenderSalaryByExperience = (GenderSalaryByExperience);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/GenderSalaryByRole.tsx





var GenderSalaryByRole = function() {
    var locale = (0,router.useRouter)().locale;
    var dataEN = [
        {
            role: "Backend Developer",
            Men: 43.55142526964561,
            Women: 35.06880733944954
        },
        {
            role: "Full-stack Developer",
            Men: 41.11195492405684,
            Women: 33.14545454545454
        },
        {
            role: "Frontend Developer",
            Men: 38.06236017897091,
            Women: 30.42138364779874
        },
        {
            role: "Mobile Developer",
            Men: 42.695595854922274,
            Women: 36.88157894736842
        },
        {
            role: "Software Architect",
            Men: 54.55178907721281,
            Women: 50.03448275862069
        },
        {
            role: "DevOps, Infrastructure & SRE",
            Men: 50.48601398601398,
            Women: 43.410714285714285
        },
        {
            role: "SysAdmin",
            Men: 39.703125,
            Women: 38.375
        },
        {
            role: "Brand Design",
            Men: 39.395348837209305,
            Women: 31.95
        },
        {
            role: "Product Manager",
            Men: 55.49312714776632,
            Women: 46.25568181818181
        },
        {
            role: "Data Analysis & BI",
            Men: 42.028517110266165,
            Women: 38.40425531914894
        },
        {
            role: "QA & Testing Engineer",
            Men: 41.729729729729726,
            Women: 36.38888888888889
        },
        {
            role: "Project & Delivery Manager",
            Men: 55.48470588235294,
            Women: 45.01456310679612
        },
        {
            role: "Data Scientist",
            Men: 42.22931034482759,
            Women: 38.644444444444446
        },
        {
            role: "Data Engineer",
            Men: 46.73150684931507,
            Women: 44.7962962962963
        },
        {
            role: "Engineering Manager",
            Men: 62.71321695760598,
            Women: 50.945945945945944
        },
        {
            role: "Tech Lead",
            Men: 58.80731364275668,
            Women: 54.85294117647059
        }
    ].sort(function(a, b) {
        return a.Women > b.Women ? -1 : 1;
    });
    var dataES = [
        {
            role: "Backend Developer",
            Hombres: 43.55142526964561,
            Mujeres: 35.06880733944954
        },
        {
            role: "Full-stack Developer",
            Hombres: 41.11195492405684,
            Mujeres: 33.14545454545454
        },
        {
            role: "Frontend Developer",
            Hombres: 38.06236017897091,
            Mujeres: 30.42138364779874
        },
        {
            role: "Mobile Developer",
            Hombres: 42.695595854922274,
            Mujeres: 36.88157894736842
        },
        {
            role: "Software Architect",
            Hombres: 54.55178907721281,
            Mujeres: 50.03448275862069
        },
        {
            role: "DevOps, Infrastructure & SRE",
            Hombres: 50.48601398601398,
            Mujeres: 43.410714285714285
        },
        {
            role: "SysAdmin",
            Hombres: 39.703125,
            Mujeres: 38.375
        },
        {
            role: "Brand Design",
            Hombres: 39.395348837209305,
            Mujeres: 31.95
        },
        {
            role: "Product Manager",
            Hombres: 55.49312714776632,
            Mujeres: 46.25568181818181
        },
        {
            role: "Data Analysis & BI",
            Hombres: 42.028517110266165,
            Mujeres: 38.40425531914894
        },
        {
            role: "QA & Testing Engineer",
            Hombres: 41.729729729729726,
            Mujeres: 36.38888888888889
        },
        {
            role: "Project & Delivery Manager",
            Hombres: 55.48470588235294,
            Mujeres: 45.01456310679612
        },
        {
            role: "Data Scientist",
            Hombres: 42.22931034482759,
            Mujeres: 38.644444444444446
        },
        {
            role: "Data Engineer",
            Hombres: 46.73150684931507,
            Mujeres: 44.7962962962963
        },
        {
            role: "Engineering Manager",
            Hombres: 62.71321695760598,
            Mujeres: 50.945945945945944
        },
        {
            role: "Tech Lead",
            Hombres: 58.80731364275668,
            Mujeres: 54.85294117647059
        }
    ].sort(function(a, b) {
        return a.Mujeres > b.Mujeres ? -1 : 1;
    });
    var data = locale === "es" ? dataES : dataEN;
    var womenKey = locale === "es" ? "Mujeres" : "Women";
    var menKey = locale === "es" ? "Hombres" : "Men";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "gender",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 650,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        data: data,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                type: "category",
                                dataKey: "role",
                                tickLine: false,
                                interval: 0,
                                angle: -60,
                                textAnchor: "end",
                                height: 250,
                                axisLine: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                width: 60,
                                axisLine: false,
                                tickMargin: 5,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                padding: {
                                    bottom: 5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    display: "none"
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€".concat(value.toFixed(1), "K");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "horizontal",
                                iconType: "square",
                                wrapperStyle: {
                                    bottom: -5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: womenKey,
                                barSize: 12,
                                radius: 5,
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: menKey,
                                barSize: 12,
                                radius: 5,
                                fill: "#1B9D76"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_GenderSalaryByRole = (GenderSalaryByRole);

// EXTERNAL MODULE: ./components/shared/CustomSelect.tsx + 1 modules
var CustomSelect = __webpack_require__(88888);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/GenderCalculator.styled.tsx

function GenderCalculator_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 15rem;\n  align-self: center;\n"
    ]);
    GenderCalculator_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    GenderCalculator_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var GenderCalculator_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-202b4268-0"
})(GenderCalculator_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledInputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-202b4268-1"
})(GenderCalculator_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"));
var StyledOutputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-202b4268-2"
})(GenderCalculator_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"));
var StyledOutput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-202b4268-3"
})(GenderCalculator_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));
var StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-202b4268-4"
})(GenderCalculator_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"));
var GenderCalculator_styled_StyledValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-202b4268-5"
})(GenderCalculator_styled_templateObject5(), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl7"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/GenderCalculator.tsx






var GenderCalculator = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var data = [
        {
            role: "Backend Developer",
            Men: 43.55142526964561,
            Women: 35.06880733944954
        },
        {
            role: "Full-stack Developer",
            Men: 41.11195492405684,
            Women: 33.14545454545454
        },
        {
            role: "Frontend Developer",
            Men: 38.06236017897091,
            Women: 30.42138364779874
        },
        {
            role: "Mobile Developer",
            Men: 42.695595854922274,
            Women: 36.88157894736842
        },
        {
            role: "Software Architect",
            Men: 54.55178907721281,
            Women: 50.03448275862069
        },
        {
            role: "DevOps & Infrastructure & SRE",
            Men: 50.48601398601398,
            Women: 43.410714285714285
        },
        {
            role: "SysAdmin",
            Men: 39.703125,
            Women: 38.375
        },
        {
            role: "Brand Design",
            Men: 39.395348837209305,
            Women: 31.95
        },
        {
            role: "Product Manager",
            Men: 55.49312714776632,
            Women: 46.25568181818181
        },
        {
            role: "Data Analysis & BI",
            Men: 42.028517110266165,
            Women: 38.40425531914894
        },
        {
            role: "QA & Testing Engineer",
            Men: 41.729729729729726,
            Women: 36.38888888888889
        },
        {
            role: "Project Manager & Delivery Manager",
            Men: 55.48470588235294,
            Women: 45.01456310679612
        },
        {
            role: "Data Scientist",
            Men: 42.22931034482759,
            Women: 38.644444444444446
        },
        {
            role: "Data Engineer",
            Men: 46.73150684931507,
            Women: 44.7962962962963
        },
        {
            role: "Engineering Management",
            Men: 62.71321695760598,
            Women: 50.945945945945944
        },
        {
            role: "Tech Lead",
            Men: 58.80731364275668,
            Women: 54.85294117647059
        }
    ];
    var roles = data.map(function(d) {
        return {
            label: d.role,
            value: d.role
        };
    });
    var ref = (0,react.useState)("--"), currentWomenalary = ref[0], setCurrentWomenalary = ref[1];
    var ref1 = (0,react.useState)("--"), currentMenalary = ref1[0], setCurrentMenalary = ref1[1];
    var handleRoleChange = function(selectedItem) {
        var found = data.find(function(d) {
            return d.role === selectedItem.value;
        });
        if (found) {
            var Women = found.Women, Men = found.Men;
            setCurrentWomenalary(Women.toFixed(1));
            setCurrentMenalary(Men.toFixed(1));
        } else {
            setCurrentWomenalary("--");
            setCurrentMenalary("--");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                    label: t("gender.form.role"),
                    forId: "genderRole",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                        options: roles,
                        id: "genderRole",
                        isSmall: true,
                        onChange: handleRoleChange,
                        defaultValue: data[0].role
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("gender.form.women")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentWomenalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("gender.form.men")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentMenalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_GenderCalculator = (GenderCalculator);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/GenderHighlight.styled.tsx

function GenderHighlight_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  padding: ",
        " ",
        ";\n  margin: ",
        " -",
        ";\n"
    ]);
    GenderHighlight_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GenderHighlight_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    GenderHighlight_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GenderHighlight_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n  list-style: none;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 1fr 1fr;\n    gap: ",
        ";\n  }\n"
    ]);
    GenderHighlight_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GenderHighlight_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 1.25rem;\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n\n  img {\n    width: 3.5rem;\n    height: 3.5rem;\n    display: block;\n  }\n"
    ]);
    GenderHighlight_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GenderHighlight_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.25;\n  position: relative;\n  margin-top: ",
        ";\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -",
        ";\n    left: 0;\n    height: ",
        ";\n    width: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    GenderHighlight_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var GenderHighlight_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cd6acd10-0"
})(GenderHighlight_styled_templateObject(), (0,theme/* color */.$_)("indigo_500"), (0,theme/* color */.$_)("text_white"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var GenderHighlight_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cd6acd10-1"
})(GenderHighlight_styled_templateObject1(), (0,theme/* container */.nC)("lg"));
var GenderHighlight_styled_StyledItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-cd6acd10-2"
})(GenderHighlight_styled_templateObject2(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var GenderHighlight_styled_StyledItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-cd6acd10-3"
})(GenderHighlight_styled_templateObject3(), (0,theme/* color */.$_)("indigo_300"), (0,theme/* radius */.q0)("md"));
var StyledRole = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-cd6acd10-4"
})(GenderHighlight_styled_templateObject4(), (0,theme/* color */.$_)("text_default"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("indigo_500"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/GenderHighlight.tsx





var GenderHighlight = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var items = [
        {
            role: t("gender.highlight.product-design"),
            icon: (0,paths/* getPublicPath */.A)("/images/stateSector/design.svg")
        },
        {
            role: t("gender.highlight.product-managament"),
            icon: (0,paths/* getPublicPath */.A)("/images/stateSector/product.svg")
        },
        {
            role: t("gender.highlight.qa"),
            icon: (0,paths/* getPublicPath */.A)("/images/stateSector/software-engineering.svg")
        },
        {
            role: t("gender.highlight.data-analysis"),
            icon: (0,paths/* getPublicPath */.A)("/images/stateSector/operations.svg")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderHighlight_styled_StyledSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderHighlight_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading4 */.k8, {
                    children: t("gender.highlight.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderHighlight_styled_StyledItems, {
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderHighlight_styled_StyledItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item.icon,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRole, {
                                    children: item.role
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_GenderHighlight = (GenderHighlight);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/GenderSection.styled.tsx

function GenderSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    GenderSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GenderSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    GenderSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GenderSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    GenderSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GenderSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    GenderSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GenderSection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    GenderSection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GenderSection_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    GenderSection_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var GenderSection_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a85b4b29-0"
})(GenderSection_styled_templateObject(), (0,theme/* color */.$_)("indigo_100"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"));
var GenderSection_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a85b4b29-1"
})(GenderSection_styled_templateObject1(), (0,theme/* container */.nC)("md"));
var GenderSection_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a85b4b29-2"
})(GenderSection_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"));
var GenderSection_styled_StyledSubsection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a85b4b29-3"
})(GenderSection_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var GenderSection_styled_StyledSubsectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a85b4b29-4"
})(GenderSection_styled_templateObject4(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("text_subtle_inverse"));
var GenderSection_styled_StyledSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a85b4b29-5"
})(GenderSection_styled_templateObject5(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl2"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/GenderSection.tsx









var GenderSection = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                as: "h2",
                                editorial: true,
                                children: t("gender.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("gender.desc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSubsection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSubsectionHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        children: t("gender.role.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("gender.role.desc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderByRole, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GenderHighlight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSubsection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSubsectionHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        children: t("gender.salary-by-role.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("gender.salary-by-role.desc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByRole, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GenderCalculator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSubsection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderSection_styled_StyledSubsectionHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        children: t("gender.salary-by-experience.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("gender.salary-by-experience.desc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByExperience, {})
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_GenderSection = (GenderSection);

// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/LinkText.tsx
var LinkText = __webpack_require__(23405);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MethodologyExperience.tsx




var MethodologyExperience = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var data = [
        {
            exp: "Not specified",
            share: 6.142611683848798
        },
        {
            exp: "<2y",
            share: 17.325315005727376
        },
        {
            exp: "2-5y",
            share: 23.883161512027492
        },
        {
            exp: "5-10y",
            share: 21.83562428407789
        },
        {
            exp: ">10y",
            share: 30.813287514318443
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: 380,
                height: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: data,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "category",
                            dataKey: "exp",
                            tickLine: false,
                            label: {
                                value: t("methodology.experience.years"),
                                position: "insideBottom",
                                offset: 0,
                                style: {
                                    transformOrigin: "center center"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            tickLine: false,
                            width: 90,
                            tickMargin: 5,
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            },
                            padding: {
                                bottom: 10
                            },
                            label: {
                                value: t("methodology.experience.share"),
                                position: "insideLeft",
                                offset: 40,
                                angle: -90
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5,
                            fill: "#4292C6"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyExperience = (MethodologyExperience);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/PieChart.js
var PieChart = __webpack_require__(43454);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/Pie.js
var Pie = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Cell.js
var Cell = __webpack_require__(11011);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MethodologyGender.tsx




var MethodologyGender = function() {
    var locale = (0,router.useRouter)().locale;
    var dataEN = [
        {
            name: "Women",
            value: 13.436102388428965
        },
        {
            name: "Men",
            value: 77.26710438671614
        },
        {
            name: "Unknown",
            value: 8.583119231135218
        }
    ];
    var dataES = [
        {
            name: "Mujeres",
            value: 13.436102388428965
        },
        {
            name: "Hombres",
            value: 77.26710438671614
        },
        {
            name: "Indeterminado",
            value: 8.583119231135218
        }
    ];
    var data = locale === "es" ? dataES : dataEN;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology gender",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 370,
                height: 220,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                        layout: "horizontal",
                        verticalAlign: "bottom",
                        iconType: "square"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        labelStyle: {
                            display: "none"
                        },
                        separator: ": ",
                        formatter: function(value) {
                            return value.toFixed(1) + "%";
                        },
                        wrapperClassName: "tooltip-y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: data,
                        dataKey: "value",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#1B9D76"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyGender = (MethodologyGender);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MethodologyRoles.tsx



var MethodologyRoles = function() {
    var data = [
        {
            language: "Backend Developer",
            value: 16.718685589776808
        },
        {
            language: "Full-stack Developer",
            value: 13.444437901183676
        },
        {
            language: "Frontend Developer",
            value: 12.513986219892821
        },
        {
            language: "Tech Lead",
            value: 4.4697014310111305
        },
        {
            language: "DevOps, Infrastructure & SRE",
            value: 3.5745833578705613
        },
        {
            language: "Software Architect",
            value: 3.3331370355102763
        },
        {
            language: "Project & Delivery Manager",
            value: 3.1918026029091338
        },
        {
            language: "Engineering Manager",
            value: 2.650020611271421
        },
        {
            language: "Mobile Developer",
            value: 2.514575113361993
        },
        {
            language: "Data Engineer",
            value: 2.320240268535422
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: 380,
                height: 310,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: data,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 5
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "language",
                            tickLine: false,
                            width: 140
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#4292C6",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyRoles = (MethodologyRoles);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/MethodologySection.styled.tsx

function MethodologySection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    MethodologySection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MethodologySection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    MethodologySection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MethodologySection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  > div {\n    max-width: ",
        ";\n  }\n"
    ]);
    MethodologySection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MethodologySection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    MethodologySection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MethodologySection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    MethodologySection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MethodologySection_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h5 {\n    color: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.2;\n    font-weight: ",
        ";\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.35em;\n  }\n  p {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n"
    ]);
    MethodologySection_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function MethodologySection_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  max-width: 23.5rem;\n"
    ]);
    MethodologySection_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var MethodologySection_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eda3ce42-0"
})(MethodologySection_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl5"));
var MethodologySection_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eda3ce42-1"
})(MethodologySection_styled_templateObject1(), (0,theme/* container */.nC)("lg"));
var MethodologySection_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eda3ce42-2"
})(MethodologySection_styled_templateObject2(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* container */.nC)("md"));
var StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-eda3ce42-3"
})(MethodologySection_styled_templateObject3(), (0,theme/* color */.$_)("text_subtle"));
var MethodologySection_styled_StyledSubsection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eda3ce42-4"
})(MethodologySection_styled_templateObject4(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var MethodologySection_styled_StyledSubsectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eda3ce42-5"
})(MethodologySection_styled_templateObject5(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eda3ce42-6"
})(MethodologySection_styled_templateObject6());
var StyledFooter = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-eda3ce42-7"
})(_templateObject7(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xl2"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/MethodologySection.tsx











var MethodologySection = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodologySection_styled_StyledSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodologySection_styled_StyledHeader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                as: "h4",
                                editorial: true,
                                alignLeft: true,
                                children: t("methodology.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                                children: t("methodology.desc")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "methodology.desc2",
                                ns: "state-of-the-sector",
                                components: {
                                    linkLogin: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.login */.uu.login, locale)
                                    })
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: t("methodology.experience.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("methodology.experience.desc")
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChart, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyExperience, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: t("methodology.roles.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    i18nKey: "methodology.roles.desc",
                                    ns: "state-of-the-sector",
                                    components: {
                                        linkRoles: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
                                            href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.roles */.uu.roles, locale)
                                        })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChart, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyRoles, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodologySection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: t("methodology.gender.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("methodology.gender.desc")
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChart, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyGender, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
                    children: t("methodology.tools")
                })
            ]
        })
    });
};
/* harmony default export */ var components_MethodologySection = (MethodologySection);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/LineChart.js
var LineChart = __webpack_require__(32908);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/CartesianGrid.js
var CartesianGrid = __webpack_require__(55484);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(63004);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/AverageSalaryByLanguage.tsx





var AverageSalaryByLanguage = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var data = [
        {
            years: "",
            JavaScript: 23.53045685279188,
            JAVA: 24.725,
            Python: 25.72340425531915,
            PHP: 25.5,
            TypeScript: 24.37837837837838,
            "C#": 25.333333333333332,
            "C++": 24.526315789473685,
            Bash: 25,
            Kotlin: 23.571428571428573,
            C: 25.63157894736842
        },
        {
            years: "<2y",
            JavaScript: 26.06553755522828,
            JAVA: 27.08128834355828,
            Python: 28.050675675675677,
            PHP: 25.473529411764705,
            TypeScript: 26.462162162162162,
            "C#": 26.82278481012658,
            "C++": 28.1171875,
            Bash: 26,
            Kotlin: 26.333333333333332,
            C: 27.48979591836735
        },
        {
            years: "2-5y",
            JavaScript: 37.70332850940666,
            JAVA: 39.10986547085202,
            Python: 42.536307053941904,
            PHP: 36.838174273858925,
            TypeScript: 41.08870967741936,
            "C#": 39.1546762589928,
            "C++": 41.69047619047619,
            Bash: 42.86764705882353,
            Kotlin: 41.669642857142854,
            C: 38.714285714285715
        },
        {
            years: "5-10y",
            JavaScript: 48.841137123745824,
            JAVA: 51.4578313253012,
            Python: 52.87290502793296,
            PHP: 45.51851851851852,
            TypeScript: 51.8891129032258,
            "C#": 49.02189781021898,
            "C++": 49.350746268656714,
            Bash: 50.82051282051282,
            Kotlin: 55.386597938144334,
            C: 48.19736842105263
        },
        {
            years: ">10y",
            JavaScript: 54.98192771084337,
            JAVA: 58.50574712643679,
            Python: 59.07309941520468,
            PHP: 52.496815286624205,
            TypeScript: 59.931472081218274,
            "C#": 54.22291666666666,
            "C++": 59.01748251748251,
            Bash: 55.859375,
            Kotlin: 61.318681318681314,
            C: 56.5625
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                        data: data,
                        margin: {
                            left: 10,
                            bottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                strokeDasharray: "1 1 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                dataKey: "years",
                                tickLine: false,
                                tickMargin: 8,
                                label: {
                                    value: t("salaries.average-by-language.years-label"),
                                    position: "insideBottom",
                                    offset: -13,
                                    style: {
                                        transformOrigin: "center center"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                tickMargin: 10,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                label: {
                                    value: t("salaries.average-by-language.salary-label"),
                                    position: "insideLeft",
                                    offset: -8,
                                    angle: -90
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    borderBottom: "1px solid #4d485c",
                                    marginBottom: "6px",
                                    fontWeight: 900
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€" + value.toFixed(1) + "K";
                                },
                                labelFormatter: function(label) {
                                    return label + " " + t("salaries.average-by-language.tooltip-years");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "vertical",
                                align: "right",
                                verticalAlign: "top",
                                iconType: "square",
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "JavaScript",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#666666"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "JAVA",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E7278A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Python",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E41B1E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "PHP",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E3A702"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "TypeScript",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#65A41E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "C#",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#A6761D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "C",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#D95F02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "C++",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1B9D76"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Bash",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Kotlin",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1E77B3"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_AverageSalaryByLanguage = (AverageSalaryByLanguage);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/AverageSalaryByRole.styled.tsx

function AverageSalaryByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n\n  ",
        " {\n    justify-content: flex-end;\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 4.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var AverageSalaryByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5dbe2dc3-0"
})(AverageSalaryByRole_styled_templateObject(), StyledAnchor);
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-5dbe2dc3-1"
})(AverageSalaryByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var AverageSalaryByRole_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5dbe2dc3-2"
})(AverageSalaryByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("ylgnbu_02"), (0,theme/* color */.$_)("ylgnbu_03"), (0,theme/* color */.$_)("ylgnbu_04"), (0,theme/* color */.$_)("ylgnbu_05"), (0,theme/* color */.$_)("ylgnbu_06"), (0,theme/* color */.$_)("ylgnbu_07"), (0,theme/* color */.$_)("ylgnbu_08"), (0,theme/* color */.$_)("ylgnbu_09"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/AverageSalaryByRole.tsx



var AverageSalaryByRole = function() {
    var data = [
        {
            role: "Backend Developer",
            tier2: 17.255717255717258,
            tier3: 21.933471933471935,
            tier4: 24.636174636174637,
            tier5: 15.557865557865558,
            tier6: 10.94941094941095,
            tier7: 3.6036036036036037,
            tier1: 6.063756063756063
        },
        {
            role: "Full-stack Developer",
            tier2: 22.491349480968857,
            tier3: 23.26989619377163,
            tier4: 22.318339100346023,
            tier5: 13.278546712802768,
            tier6: 8.780276816608996,
            tier7: 2.63840830449827,
            tier1: 7.2231833910034595
        },
        {
            role: "Frontend Developer",
            tier2: 28.84259259259259,
            tier3: 22.824074074074076,
            tier4: 17.453703703703706,
            tier5: 10.416666666666668,
            tier6: 6.5740740740740735,
            tier7: 1.8518518518518516,
            tier1: 12.037037037037036
        },
        {
            role: "Mobile Developer",
            tier2: 19.20374707259953,
            tier3: 22.716627634660423,
            tier4: 18.26697892271663,
            tier5: 15.22248243559719,
            tier6: 12.177985948477751,
            tier7: 4.449648711943794,
            tier1: 7.962529274004685
        },
        {
            role: "Software Architect",
            tier2: 5.982905982905983,
            tier3: 9.572649572649574,
            tier4: 21.70940170940171,
            tier5: 24.957264957264957,
            tier6: 25.299145299145298,
            tier7: 10.76923076923077,
            tier1: 1.7094017094017095
        },
        {
            role: "DevOps & Infrastructure & SRE",
            tier2: 10.416666666666668,
            tier3: 15.384615384615385,
            tier4: 23.23717948717949,
            tier5: 21.474358974358974,
            tier6: 19.391025641025642,
            tier7: 7.211538461538461,
            tier1: 2.8846153846153846
        },
        {
            role: "SysAdmin",
            tier2: 19.753086419753085,
            tier3: 28.80658436213992,
            tier4: 22.22222222222222,
            tier5: 13.580246913580247,
            tier6: 7.818930041152264,
            tier7: 2.05761316872428,
            tier1: 5.761316872427984
        },
        {
            role: "Brand Design",
            tier2: 26.82926829268293,
            tier3: 30.48780487804878,
            tier4: 9.75609756097561,
            tier5: 12.195121951219512,
            tier6: 2.4390243902439024,
            tier7: 2.4390243902439024,
            tier1: 15.853658536585366
        },
        {
            role: "Product Manager",
            tier2: 5.83756345177665,
            tier3: 17.00507614213198,
            tier4: 20.304568527918782,
            tier5: 23.096446700507613,
            tier6: 25.63451776649746,
            tier7: 7.868020304568528,
            tier1: 0.25380710659898476
        },
        {
            role: "Data Analysis & BI",
            tier2: 21.428571428571427,
            tier3: 23.91304347826087,
            tier4: 23.91304347826087,
            tier5: 14.906832298136646,
            tier6: 9.316770186335404,
            tier7: 2.484472049689441,
            tier1: 4.037267080745342
        },
        {
            role: "QA & Testing Engineer",
            tier2: 23.076923076923077,
            tier3: 21.428571428571427,
            tier4: 20.87912087912088,
            tier5: 15.934065934065933,
            tier6: 9.89010989010989,
            tier7: 2.197802197802198,
            tier1: 6.593406593406594
        },
        {
            role: "Project Manager & Delivery Manager",
            tier2: 6.839186691312385,
            tier3: 12.384473197781885,
            tier4: 22.920517560073936,
            tier5: 24.214417744916823,
            tier6: 26.98706099815157,
            tier7: 6.654343807763401,
            tier1: 0
        },
        {
            role: "Data Scientist",
            tier2: 21.48997134670487,
            tier3: 24.355300859598856,
            tier4: 19.484240687679083,
            tier5: 15.759312320916905,
            tier6: 9.742120343839542,
            tier7: 4.297994269340974,
            tier1: 4.871060171919771
        },
        {
            role: "Data Engineer",
            tier2: 13.58974358974359,
            tier3: 21.28205128205128,
            tier4: 21.025641025641026,
            tier5: 20.76923076923077,
            tier6: 16.666666666666664,
            tier7: 4.358974358974359,
            tier1: 2.307692307692308
        },
        {
            role: "Engineering Management",
            tier2: 2.9213483146067416,
            tier3: 4.269662921348314,
            tier4: 12.584269662921349,
            tier5: 22.02247191011236,
            tier6: 37.52808988764045,
            tier7: 20,
            tier1: 0.6741573033707865
        },
        {
            role: "Tech Lead",
            tier2: 1.532567049808429,
            tier3: 7.535121328224776,
            tier4: 19.923371647509576,
            tier5: 26.56449553001277,
            tier6: 29.88505747126437,
            tier7: 14.17624521072797,
            tier1: 0.38314176245210724
        }
    ];
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "<20K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€20-30K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€31-40K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€41-50K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€51-60K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "€61-80K"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: ">80K"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: data.map(function(data, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: data.role
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier1),
                                            children: [
                                                data.tier1.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier2),
                                            children: [
                                                data.tier2.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier3),
                                            children: [
                                                data.tier3.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier4),
                                            children: [
                                                data.tier4.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier5),
                                            children: [
                                                data.tier5.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier6),
                                            children: [
                                                data.tier6.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AverageSalaryByRole_styled_StyledValue, {
                                            className: getClassColor(data.tier7),
                                            children: [
                                                data.tier7.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_AverageSalaryByRole = (AverageSalaryByRole);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/AverageSalaryByTechnology.tsx





var AverageSalaryByTechnology = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var data = [
        {
            years: "",
            CSS: 23.16857142857143,
            React: 23.603448275862068,
            MySQL: 23.628205128205128,
            HTML: 23.279141104294478,
            Git: 23.796875,
            Docker: 26.394736842105264,
            SQL: 26.036585365853657,
            NodeJS: 23.113095238095237,
            MongoDB: 23.50943396226415,
            AWS: 28.444444444444446
        },
        {
            years: "<2y",
            CSS: 25.377840909090907,
            React: 26.059151785714285,
            MySQL: 25.84697508896797,
            HTML: 25.37953091684435,
            Git: 27.088709677419356,
            Docker: 28.316037735849054,
            SQL: 26.77777777777778,
            NodeJS: 26.03146853146853,
            MongoDB: 26.893617021276597,
            AWS: 31.41176470588235
        },
        {
            years: "2-5y",
            CSS: 35.61049107142857,
            React: 38.77317073170732,
            MySQL: 38.018840579710144,
            HTML: 35.39650537634409,
            Git: 38.99515738498789,
            Docker: 42.1554054054054,
            SQL: 39.566343042071196,
            NodeJS: 39.33859649122807,
            MongoDB: 39.98031496062992,
            AWS: 44.98774509803922
        },
        {
            years: "5-10y",
            CSS: 46.70847457627119,
            React: 51.39966555183946,
            MySQL: 47.98691860465116,
            HTML: 46.1875,
            Git: 50.155325443786985,
            Docker: 52.42524916943521,
            SQL: 50.3195020746888,
            NodeJS: 52.16822429906542,
            MongoDB: 51.807870370370374,
            AWS: 56.35040983606558
        },
        {
            years: ">10y",
            CSS: 50.37602179836512,
            React: 58.94366197183099,
            MySQL: 54.005692599620495,
            HTML: 50.6,
            Git: 54.91219512195122,
            Docker: 60.262472885032544,
            SQL: 56.474393530997304,
            NodeJS: 57.336776859504134,
            MongoDB: 58.427304964539005,
            AWS: 62.56390977443609
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    height: 400,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                        data: data,
                        margin: {
                            left: 10,
                            bottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartesianGrid/* CartesianGrid */.q, {
                                strokeDasharray: "1 1 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                dataKey: "years",
                                tickLine: false,
                                tickMargin: 8,
                                label: {
                                    value: t("salaries.average-by-language.years-label"),
                                    position: "insideBottom",
                                    offset: -13,
                                    style: {
                                        transformOrigin: "center center"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                tickLine: false,
                                tickMargin: 10,
                                tickFormatter: function(tick) {
                                    return "€".concat(tick, "K");
                                },
                                label: {
                                    value: t("salaries.average-by-language.salary-label"),
                                    position: "insideLeft",
                                    offset: -8,
                                    angle: -90
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                cursor: {
                                    fill: "transparent"
                                },
                                labelStyle: {
                                    borderBottom: "1px solid #4d485c",
                                    marginBottom: "6px",
                                    fontWeight: 900
                                },
                                separator: ": ",
                                formatter: function(value) {
                                    return "€" + value.toFixed(1) + "K";
                                },
                                labelFormatter: function(label) {
                                    return label + " " + t("salaries.average-by-language.tooltip-years");
                                },
                                wrapperClassName: "tooltip-x"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                                layout: "vertical",
                                align: "right",
                                verticalAlign: "top",
                                iconType: "square",
                                width: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "CSS",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E7278A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "React",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#666666"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "MySQL",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E3A702"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "HTML",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#E41B1E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Git",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#65A41E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "Docker",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#A6761D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "SQL",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#D95F02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "NodeJS",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1B9D76"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "MongoDB",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#746FB3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                dataKey: "AWS",
                                dot: false,
                                strokeWidth: 2,
                                stroke: "#1E77B3"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
        ]
    });
};
/* harmony default export */ var charts_AverageSalaryByTechnology = (AverageSalaryByTechnology);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/generateCategoricalChart.js + 7 modules
var generateCategoricalChart = __webpack_require__(39592);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/PolarAngleAxis.js
var PolarAngleAxis = __webpack_require__(79669);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/PolarRadiusAxis.js
var PolarRadiusAxis = __webpack_require__(10086);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/PolarUtils.js
var PolarUtils = __webpack_require__(22089);
// EXTERNAL MODULE: ../../node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18149);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/lodash/isFunction.js
var isFunction = __webpack_require__(61049);
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);
// EXTERNAL MODULE: ../../node_modules/lodash/isArray.js
var isArray = __webpack_require__(86152);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-smooth/es6/index.js + 8 modules
var es6 = __webpack_require__(33057);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/shape/Sector.js
var Sector = __webpack_require__(21844);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/container/Layer.js
var Layer = __webpack_require__(84618);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/ReactUtils.js
var ReactUtils = __webpack_require__(79376);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/Global.js
var Global = __webpack_require__(79499);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/LabelList.js
var LabelList = __webpack_require__(96621);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/DataUtils.js
var DataUtils = __webpack_require__(15027);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/ChartUtils.js + 89 modules
var ChartUtils = __webpack_require__(39442);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/types.js
var types = __webpack_require__(21442);
;// CONCATENATED MODULE: ../../node_modules/recharts/es6/polar/RadialBar.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @fileOverview Render a group of radial bar
 */












 // TODO: Cause of circular dependency. Needs refactoring of functions that need them.
// import { AngleAxisProps, RadiusAxisProps } from './types';

var RadialBar = /*#__PURE__*/function (_PureComponent) {
  _inherits(RadialBar, _PureComponent);

  var _super = _createSuper(RadialBar);

  function RadialBar() {
    var _this;

    _classCallCheck(this, RadialBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isAnimationFinished: false
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (isFunction_default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (isFunction_default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(RadialBar, [{
    key: "getDeltaAngle",
    value: function getDeltaAngle() {
      var _this$props = this.props,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle;
      var sign = (0,DataUtils/* mathSign */.uY)(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
      return sign * deltaAngle;
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;

      var _this$props2 = this.props,
          shape = _this$props2.shape,
          activeShape = _this$props2.activeShape,
          activeIndex = _this$props2.activeIndex,
          cornerRadius = _this$props2.cornerRadius,
          others = _objectWithoutProperties(_this$props2, ["shape", "activeShape", "activeIndex", "cornerRadius"]);

      var baseProps = (0,types/* filterProps */.L6)(others);
      return sectors.map(function (entry, i) {
        var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseProps), {}, {
          cornerRadius: cornerRadius
        }, entry), (0,types/* adaptEventsOfChild */.bw)(_this2.props, entry, i)), {}, {
          key: "sector-".concat(i),
          className: 'recharts-radial-bar-sector',
          forceCornerRadius: others.forceCornerRadius,
          cornerIsExternal: others.cornerIsExternal
        });

        return RadialBar.renderSectorShape(i === activeIndex ? activeShape : shape, props);
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;

      var _this$props3 = this.props,
          data = _this$props3.data,
          isAnimationActive = _this$props3.isAnimationActive,
          animationBegin = _this$props3.animationBegin,
          animationDuration = _this$props3.animationDuration,
          animationEasing = _this$props3.animationEasing,
          animationId = _this$props3.animationId;
      var prevData = this.state.prevData;
      return /*#__PURE__*/react.createElement(es6/* default */.ZP, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radialBar-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];

          if (prev) {
            var interpolatorStartAngle = (0,DataUtils/* interpolateNumber */.k4)(prev.startAngle, entry.startAngle);
            var interpolatorEndAngle = (0,DataUtils/* interpolateNumber */.k4)(prev.endAngle, entry.endAngle);
            return _objectSpread(_objectSpread({}, entry), {}, {
              startAngle: interpolatorStartAngle(t),
              endAngle: interpolatorEndAngle(t)
            });
          }

          var endAngle = entry.endAngle,
              startAngle = entry.startAngle;
          var interpolator = (0,DataUtils/* interpolateNumber */.k4)(startAngle, endAngle);
          return _objectSpread(_objectSpread({}, entry), {}, {
            endAngle: interpolator(t)
          });
        });
        return /*#__PURE__*/react.createElement(Layer/* Layer */.m, null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props4 = this.props,
          data = _this$props4.data,
          isAnimationActive = _this$props4.isAnimationActive;
      var prevData = this.state.prevData;

      if (isAnimationActive && data && data.length && (!prevData || !isEqual_default()(prevData, data))) {
        return this.renderSectorsWithAnimation();
      }

      return this.renderSectorsStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(sectors) {
      var _this4 = this;

      var cornerRadius = this.props.cornerRadius;
      var backgroundProps = (0,types/* filterProps */.L6)(this.props.background);
      return sectors.map(function (entry, i) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ["value", "background"]);

        if (!background) {
          return null;
        }

        var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          cornerRadius: cornerRadius
        }, rest), {}, {
          fill: '#eee'
        }, background), backgroundProps), (0,types/* adaptEventsOfChild */.bw)(_this4.props, entry, i)), {}, {
          index: i,
          key: "sector-".concat(i),
          className: 'recharts-radial-bar-background-sector'
        });

        return RadialBar.renderSectorShape(background, props);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          hide = _this$props5.hide,
          data = _this$props5.data,
          className = _this$props5.className,
          background = _this$props5.background,
          isAnimationActive = _this$props5.isAnimationActive;

      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = classnames_default()('recharts-area', className);
      return /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        className: layerClass
      }, background && /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        className: "recharts-radial-bar-background"
      }, this.renderBackground(data)), /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        className: "recharts-radial-bar-sectors"
      }, this.renderSectors()), (!isAnimationActive || isAnimationFinished) && LabelList/* LabelList.renderCallByParent */.e.renderCallByParent(_objectSpread(_objectSpread({}, this.props), {}, {
        clockWise: this.getDeltaAngle() < 0
      }), data));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curData: nextProps.data,
          prevData: prevState.curData
        };
      }

      if (nextProps.data !== prevState.curData) {
        return {
          curData: nextProps.data
        };
      }

      return null;
    }
  }, {
    key: "renderSectorShape",
    value: function renderSectorShape(shape, props) {
      var sectorShape;

      if ( /*#__PURE__*/react.isValidElement(shape)) {
        sectorShape = /*#__PURE__*/react.cloneElement(shape, props);
      } else if (isFunction_default()(shape)) {
        sectorShape = shape(props);
      } else {
        sectorShape = /*#__PURE__*/react.createElement(Sector/* Sector */.L, props);
      }

      return sectorShape;
    }
  }]);

  return RadialBar;
}(react.PureComponent);
RadialBar.displayName = 'RadialBar';
RadialBar.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  minPointSize: 0,
  hide: false,
  legendType: 'rect',
  data: [],
  isAnimationActive: !Global/* Global.isSsr */.x.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  forceCornerRadius: false,
  cornerIsExternal: false
};

RadialBar.getComposedData = function (_ref2) {
  var item = _ref2.item,
      props = _ref2.props,
      radiusAxis = _ref2.radiusAxis,
      radiusAxisTicks = _ref2.radiusAxisTicks,
      angleAxis = _ref2.angleAxis,
      angleAxisTicks = _ref2.angleAxisTicks,
      displayedData = _ref2.displayedData,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData,
      barPosition = _ref2.barPosition,
      bandSize = _ref2.bandSize,
      dataStartIndex = _ref2.dataStartIndex;
  var pos = (0,ChartUtils/* findPositionOfBar */.Bu)(barPosition, item);

  if (!pos) {
    return null;
  }

  var cx = angleAxis.cx,
      cy = angleAxis.cy;
  var layout = props.layout;
  var _item$props = item.props,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = (0,ChartUtils/* getBaseValueOfBar */.Yj)({
    numericAxis: numericAxis
  });
  var cells = (0,ReactUtils/* findAllByType */.NN)(children, Cell/* Cell.displayName */.b.displayName);
  var sectors = displayedData.map(function (entry, index) {
    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;

    if (stackedData) {
      value = (0,ChartUtils/* truncateByDomain */.Vv)(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = (0,ChartUtils/* getValueByDataKey */.F$)(entry, dataKey);

      if (!isArray_default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'radial') {
      innerRadius = (0,ChartUtils/* getCateCoordinateOfBar */.Fy)({
        axis: radiusAxis,
        ticks: radiusAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = angleAxis.scale(value[1]);
      startAngle = angleAxis.scale(value[0]);
      outerRadius = innerRadius + pos.size;
      var deltaAngle = endAngle - startAngle;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
        var delta = (0,DataUtils/* mathSign */.uY)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
        endAngle += delta;
      }

      backgroundSector = {
        background: {
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: props.startAngle,
          endAngle: props.endAngle
        }
      };
    } else {
      innerRadius = radiusAxis.scale(value[0]);
      outerRadius = radiusAxis.scale(value[1]);
      startAngle = (0,ChartUtils/* getCateCoordinateOfBar */.Fy)({
        axis: angleAxis,
        ticks: angleAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = startAngle + pos.size;
      var deltaRadius = outerRadius - innerRadius;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
        var _delta = (0,DataUtils/* mathSign */.uY)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));

        outerRadius += _delta;
      }
    }

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entry), backgroundSector), {}, {
      payload: entry,
      value: stackedData ? value : value[1],
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    }, cells && cells[index] && cells[index].props), {}, {
      tooltipPayload: [(0,ChartUtils/* getTooltipItem */.Qo)(item, entry)],
      tooltipPosition: (0,PolarUtils/* polarToCartesian */.op)(cx, cy, (innerRadius + outerRadius) / 2, (startAngle + endAngle) / 2)
    });
  });
  return {
    data: sectors,
    layout: layout
  };
};
;// CONCATENATED MODULE: ../../node_modules/recharts/es6/chart/RadialBarChart.js
/**
 * @fileOverview Radar Bar Chart
 */





var RadialBarChart = (0,generateCategoricalChart/* generateCategoricalChart */.z)({
  chartName: 'RadialBarChart',
  GraphicalChild: RadialBar,
  legendContent: 'children',
  defaultTooltipEventType: 'axis',
  validateTooltipEventTypes: ['axis', 'item'],
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: PolarAngleAxis/* PolarAngleAxis */.I
  }, {
    axisType: 'radiusAxis',
    AxisComp: PolarRadiusAxis/* PolarRadiusAxis */.S
  }],
  formatAxisMap: PolarUtils/* formatAxisMap */.t9,
  defaultProps: {
    layout: 'radial',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  }
});
// EXTERNAL MODULE: ./services/multilingual.service.ts
var multilingual_service = __webpack_require__(21428);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/charts/MostOfferedPerks.tsx





var MostOfferedPerks = function() {
    var locale = (0,router.useRouter)().locale;
    var data = [
        {
            name: {
                EN: "Teambuilding events and dynamics",
                ES: "Din\xe1micas y eventos de teambuilding"
            },
            value: 53.23275862068966,
            fill: "#E7278A"
        },
        {
            name: {
                EN: "Budget for training",
                ES: "Presupuesto para formaci\xf3n"
            },
            value: 51.939655172413794,
            fill: "#E3A702"
        },
        {
            name: {
                EN: "Internal training events",
                ES: "Eventos de formaci\xf3n internos"
            },
            value: 44.396551724137936,
            fill: "#E41B1E"
        },
        {
            name: {
                EN: "Private health insurance",
                ES: "Seguro de salud"
            },
            value: 36.206896551724135,
            fill: "#65A41E"
        },
        {
            name: {
                EN: "Budget for conferences",
                ES: "Presupuesto para Conferencias"
            },
            value: 31.896551724137932,
            fill: "#A6761D"
        },
        {
            name: {
                EN: "Language classes",
                ES: "Clases de Idiomas"
            },
            value: 31.68103448275862,
            fill: "#D95F02"
        },
        {
            name: {
                EN: "Possibility to choose your devices",
                ES: "Posibilidad de elegir equipo"
            },
            value: 29.95689655172414,
            fill: "#1B9D76"
        },
        {
            name: {
                EN: "Extra days of annual leave",
                ES: "Vacaciones Extra"
            },
            value: 29.310344827586203,
            fill: "#746FB3"
        },
        {
            name: {
                EN: "Free coffee, fruit and snacks",
                ES: "Caf\xe9, fruta y snacks"
            },
            value: 22.198275862068968,
            fill: "#1E77B3"
        }
    ].map(function(param) {
        var name = param.name, value = param.value, fill = param.fill;
        return {
            name: (0,multilingual_service/* getTranslatedText */.G)(name, locale),
            value: value,
            fill: fill
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "radial",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 550,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadialBarChart, {
                    innerRadius: "10%",
                    outerRadius: "80%",
                    data: data,
                    startAngle: 180,
                    endAngle: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadialBar, {
                            background: true,
                            dataKey: "value"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            iconType: "square",
                            layout: "horizontal",
                            verticalAlign: "bottom",
                            align: "center"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                stroke: "rgba(255, 255, 255, .5)"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostOfferedPerks = (MostOfferedPerks);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/OfferedPerks.styled.tsx

function OfferedPerks_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: ",
        ") {\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n    flex-direction: row;\n    gap: ",
        ";\n  }\n\n  > :first-child {\n    max-width: 22rem;\n    width: 100%;\n    flex-shrink: 0;\n  }\n\n  ",
        " {\n    margin-left: 0;\n  }\n"
    ]);
    OfferedPerks_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OfferedPerks_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    OfferedPerks_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var OfferedPerks_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e204a696-0"
})(OfferedPerks_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl2"), StyledAnchor);
var OfferedPerks_styled_StyledChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e204a696-1"
})(OfferedPerks_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/OfferedPerks.tsx






var OfferedPerks = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfferedPerks_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                        children: t("salaries.perks.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: t("salaries.perks.desc")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologyAnchor, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferedPerks_styled_StyledChart, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostOfferedPerks, {})
            })
        ]
    });
};
/* harmony default export */ var components_OfferedPerks = (OfferedPerks);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/SalariesSection.styled.tsx

function SalariesSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    SalariesSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalariesSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    SalariesSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalariesSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    SalariesSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalariesSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    SalariesSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalariesSection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    SalariesSection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SalariesSection_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: center;\n    gap: ",
        ";\n  }\n"
    ]);
    SalariesSection_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SalariesSection_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    SalariesSection_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var SalariesSection_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-0"
})(SalariesSection_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"));
var SalariesSection_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-1"
})(SalariesSection_styled_templateObject1(), (0,theme/* container */.nC)("md"));
var SalariesSection_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-2"
})(SalariesSection_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"));
var SalariesSection_styled_StyledSubsection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-3"
})(SalariesSection_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var SalariesSection_styled_StyledSubsectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-4"
})(SalariesSection_styled_templateObject4(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("text_subtle_inverse"));
var SalariesSection_styled_StyledSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-5"
})(SalariesSection_styled_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"));
var SalariesSection_styled_StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cc48b66d-6"
})(SalariesSection_styled_templateObject6(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* color */.$_)("navy_300"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/SalariesSection.tsx










var SalariesSection = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var ref = (0,react.useState)(true), averageByLang = ref[0], setAverageByLang = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SalariesSection_styled_StyledSection, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                            as: "h2",
                            editorial: true,
                            children: t("salaries.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("salaries.desc")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                    children: t("salaries.average-by-language.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("salaries.average-by-language.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledSwitcher, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                    name: "averageByLang",
                                    id: "averageByLang",
                                    label: t("salaries.average-by-language.switcher.languages"),
                                    onChange: function() {
                                        return setAverageByLang(true);
                                    },
                                    checked: averageByLang
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                    name: "averageByLang",
                                    id: "averageByTech",
                                    label: t("salaries.average-by-language.switcher.technologies"),
                                    onChange: function() {
                                        return setAverageByLang(false);
                                    },
                                    checked: !averageByLang
                                })
                            ]
                        }),
                        averageByLang && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_AverageSalaryByLanguage, {}),
                        !averageByLang && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_AverageSalaryByTechnology, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledSubsection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SalariesSection_styled_StyledSubsectionHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                    children: t("salaries.average-by-role.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("salaries.average-by-role.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_AverageSalaryByRole, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OfferedPerks, {})
            ]
        })
    });
};
/* harmony default export */ var components_SalariesSection = (SalariesSection);

// EXTERNAL MODULE: ./components/layout/footer/Footer.tsx
var Footer = __webpack_require__(70995);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(66582);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ./components/layout/footer/Footer.styled.tsx
var Footer_styled = __webpack_require__(59072);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/StateOfTheSectorFooter.styled.tsx

function StateOfTheSectorFooter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  background-image: linear-gradient(\n      ",
        ",\n      ",
        "\n    ),\n    url('",
        "');\n  background-size: cover;\n  padding-top: 5rem;\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: 10rem;\n  }\n\n  ",
        " {\n    background: transparent;\n  }\n"
    ]);
    StateOfTheSectorFooter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StateOfTheSectorFooter_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    StateOfTheSectorFooter_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StateOfTheSectorFooter_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  @media (min-width: ",
        ") {\n    flex-direction: row-reverse;\n  }\n"
    ]);
    StateOfTheSectorFooter_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StateOfTheSectorFooter_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  img {\n    display: block;\n    width: 17rem;\n    height: auto;\n  }\n  p {\n    text-align: center;\n    font-size: ",
        ";\n    line-height: 1.57;\n    margin-top: ",
        ";\n    margin-bottom: 0;\n  }\n"
    ]);
    StateOfTheSectorFooter_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function StateOfTheSectorFooter_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.25rem;\n  margin-bottom: ",
        ";\n"
    ]);
    StateOfTheSectorFooter_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function StateOfTheSectorFooter_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    StateOfTheSectorFooter_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var StateOfTheSectorFooter_styled_StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-fbe39630-0"
})(StateOfTheSectorFooter_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,polished_esm/* rgba */.m4)("#1f1d26", 0.75), (0,polished_esm/* rgba */.m4)("#1f1d26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/hero-bg.gif"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* screen */.sp)("lg"), Footer_styled/* StyledFooter */.tc);
var StyledFooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fbe39630-1"
})(StateOfTheSectorFooter_styled_templateObject1(), (0,theme/* container */.nC)("xlMax"));
var StyledFooterNavCopy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fbe39630-2"
})(StateOfTheSectorFooter_styled_templateObject2(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledFooterLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fbe39630-3"
})(StateOfTheSectorFooter_styled_templateObject3(), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("md"));
var StyledFooterCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fbe39630-4"
})(StateOfTheSectorFooter_styled_templateObject4(), (0,theme/* spacing */.W0)("xl3"));
var StyledFooterCopyright = styled_components_browser_esm/* default.small.withConfig */.ZP.small.withConfig({
    componentId: "sc-fbe39630-5"
})(StateOfTheSectorFooter_styled_templateObject5(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/StateOfTheSectorFooter.tsx

function StateOfTheSectorFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  body {\n    padding-bottom: ",
        ";\n  }\n\n  @media (max-height: ",
        ") {\n    body {\n      padding-bottom: 0 !important;\n    }\n    .main-footer {\n      position: static !important;\n    }\n  }\n"
    ]);
    StateOfTheSectorFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(StateOfTheSectorFooter_templateObject(), function(props) {
    return props.footerHeight ? props.footerHeight + "px !important" : "";
}, function(props) {
    return props.footerHeight + "px";
});
var StateOfTheSectorFooter = function() {
    var footerHeight = function footerHeight() {
        if (footerRef === null || footerRef === void 0 ? void 0 : footerRef.current) {
            setHeight(footerRef.current.clientHeight);
        }
    };
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(0), height = ref[0], setHeight = ref[1];
    var footerRef = (0,react.useRef)(null);
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    (0,react.useEffect)(function() {
        footerHeight();
        var triggerEvent = lib/* isMobile */.tq ? "orientationchange" : "resize";
        window.addEventListener(triggerEvent, footerHeight);
        return function() {
            window.removeEventListener(triggerEvent, footerHeight);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {
                footerHeight: height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StateOfTheSectorFooter_styled_StyledFooter, {
                ref: footerRef,
                className: "main-footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterLogo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: logos/* LOGO_MANFRED_WHITE */.YM,
                                        alt: "Manfred logo",
                                        width: "132",
                                        height: "24"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("footer.claim")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterCta, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-career-report"),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                                        variant: "brandTalent",
                                        onClick: function(e) {
                                            return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-career-report"), "footer-career-report");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("footer.cta")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        isInCustomFooter: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_StateOfTheSectorFooter = (StateOfTheSectorFooter);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/StateOfTheSectorHero.styled.tsx

function StateOfTheSectorHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  background-image: linear-gradient(\n      ",
        ",\n      ",
        "\n    ),\n    url('",
        "');\n  background-size: cover;\n  padding: ",
        " ",
        " ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  &::after {\n    background-image: ",
        ";\n    content: '';\n    background-position: top;\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: block;\n    width: calc(100% + ",
        ");\n    height: 8rem;\n    position: absolute;\n    bottom: 0;\n    left: -",
        ";\n    right: -",
        ";\n  }\n"
    ]);
    StateOfTheSectorHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StateOfTheSectorHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    StateOfTheSectorHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StateOfTheSectorHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    StateOfTheSectorHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StateOfTheSectorHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  span {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 1;\n    color: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n    letter-spacing: 0.35em;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    StateOfTheSectorHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bf8b1f9-0"
})(StateOfTheSectorHero_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,polished_esm/* rgba */.m4)("#1f1d26", 0.75), (0,polished_esm/* rgba */.m4)("#1f1d26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/hero-bg.gif"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl7"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateSector/curve-bg.svg"), "')");
}, (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledHeroCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bf8b1f9-1"
})(StateOfTheSectorHero_styled_templateObject1());
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3bf8b1f9-2"
})(StateOfTheSectorHero_styled_templateObject2(), (0,theme/* container */.nC)("lg"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-3bf8b1f9-3"
})(StateOfTheSectorHero_styled_templateObject3(), (0,theme/* color */.$_)("mint_500"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl7"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/components/StateOfTheSectorHero.tsx










var ShareModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1539).then(__webpack_require__.bind(__webpack_require__, 9011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9011)
            ];
        }
    },
    ssr: false
});
var StateOfTheSectorHero = function() {
    var locale = (0,router.useRouter)().locale;
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var ref = (0,react.useState)(false), isShareModalOpened = ref[0], setIsShareModalOpened = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("hero.pre-title")
                            }),
                            t("hero.title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("hero.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroCta, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                            variant: "brandTalent",
                            type: "button",
                            sizes: "sm",
                            onClick: function() {
                                return setIsShareModalOpened(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faShareSquare */.tFX
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("hero.cta")
                                })
                            ]
                        })
                    })
                ]
            }),
            isShareModalOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal, {
                isOpened: isShareModalOpened,
                close: function() {
                    return setIsShareModalOpened(false);
                },
                url: "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar25 */.uu.mantechcar25, locale)),
                emailSubject: t("share-modal.email-subject"),
                twitterMessage: t("share-modal.text"),
                telegramMessage: t("share-modal.text"),
                whatsappMessage: t("share-modal.text"),
                emailMessage: t("share-modal.email-text")
            })
        ]
    });
};
/* harmony default export */ var components_StateOfTheSectorHero = (StateOfTheSectorHero);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfTheSector/StateOfTheSectorComponent.tsx












var StateOfTheSectorComponent = function() {
    //const { locale } = useRouter();
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    var sections = [
        {
            section: "hero",
            tooltip: t("nav.hero")
        },
        {
            section: "developers",
            tooltip: t("nav.developers")
        },
        {
            section: "salaries",
            tooltip: t("nav.salaries")
        },
        {
            section: "companies",
            tooltip: t("nav.companies")
        },
        {
            section: "gender",
            tooltip: t("nav.gender")
        },
        {
            section: "methodology",
            tooltip: t("nav.methodology")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        sections: sections,
        customFooter: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StateOfTheSectorFooter, {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "inicio",
                id: "hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StateOfTheSectorHero, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "developers",
                id: "developers",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DevelopersSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "salaries",
                id: "salaries",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalariesSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Benchmark, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "companies",
                id: "companies",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompaniesSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "gender",
                id: "gender",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GenderSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "methodology",
                id: "methodology",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MethodologySection, {})
            })
        ]
    });
};
/* harmony default export */ var stateOfTheSector_StateOfTheSectorComponent = (StateOfTheSectorComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/developer-career-report-2022.tsx







var StateOfTheSectorPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("state-of-the-sector").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("page_title"),
                url: app_urls/* APP_URLS.mandecar22 */.uu.mandecar22,
                desc: t("page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_state_of_the_sector.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateOfTheSector_StateOfTheSectorComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var developer_career_report_2022 = (StateOfTheSectorPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,6582,8746,9001,2077,3004,4926,3454,625,4882,289,7566,9774,2888,179], function() { return __webpack_exec__(24697); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);